<span class="section-title key-insights">Key Insights</span>
<div class="row section-container">
    <div class="col-xl-10 offset-xl-1 col-lg-12 key-insights">
        <div class="row">
            <div class="col-md-4"><strong>{{reportData?.reserveAccountBalance | currency:'USD':'symbol-narrow':'1.0-0' }}</strong><span>Reserve Account Balance</span></div>
            <div class="col-md-4"><strong>{{reportData?.contributionsToReserves | currency:'USD':'symbol-narrow':'1.0-0' }}</strong><span>Contributions to Reserves</span></div>
            <div class="col-md-4"><strong>{{reportData?.totalAnticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0' }}</strong><span>Anticipated Expenditures for this Year</span></div>
        </div>
    </div>
</div>

<!-- No Data Message -->
<div *ngIf="hasNoComponents" class="no-components-msg">
    <div class="icon-container">
        <i class="fa-regular fa-folder-open fa-3x"></i>
    </div>
    <div>
        <h3 class="margin-top-25">Start adding {{ 'components' | terminology | async }} for your property!</h3>
        <p class="margin-top-25 font-light">Before we can generate the dashboard, you need to add {{ 'components' | terminology | async }}.</p>
        <a class="btn btn-success" [routerLink]="['/useraccount/components']">
            Manage Your {{ 'Components' | terminology | async }}
        </a>
    </div>

    <div *spHasRole="['Vendor', 'Member']">
        <h3 class="margin-top-25">There are no {{ 'components' | terminology | async }} for your property</h3>
        <p class="margin-top-25 font-light">Contact your account administrator about adding {{ 'components' | terminology | async }}.</p>
    </div>
</div>

<div [hidden]="hasNoComponents">
    <div class="row">
        <div class="col-md-6">
            <span class="section-title margin-top-20">What's the financial condition of your reserves?</span>
            <div class="row section-container section-height">
                <div class="col-md-12 financial-strength">
                    <div class="row">
                        <div class="col-md-12">
                            <p>Your financial condition today is measured in your ability to pay for your
                                replacement reserves given the amount of cash you have in the bank, how much
                                your expenses are, and when they'll be due. This is called "percent funded"
                                and it's an indicator of your financial strength. A lower number means you
                                may not be able to afford repairs.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 text-center margin-top-60">
                            <strong>{{reportData?.percentageFunded | number:'1.0-0' }}<i class="fa fa-percent" aria-hidden="true"></i></strong>
                        </div>
                        <div class="col-md-8 text-center">
                           <sp-percent-funded-gauge [percentageFunded]="reportData?.percentageFunded"></sp-percent-funded-gauge>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-end">
                            <a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/percent-funded']">View Percent Funded Report</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <span class="section-title margin-top-20">What's on the calendar for this year</span>
            <div class="row section-container section-height">
                <div class="col-md-12 anticipated-expenditures">
                    <p>The list below is a roadmap for projects that are scheduled to be replaced, repaired or maintained in the upcoming budget year.</p>
                    <table class="table table-sm">
                        <thead class="thead-light">
                        <tr>
                            <th scope="col">Top Anticipated Expenditures</th>
                            <th scope="col" class="text-end">Replacement Costs</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let propertyComponent of reportData?.topExpenditures">
                            <td><a class="btn btn-link padding-left-0 component-name" [routerLink]="['/useraccount/components', propertyComponent.propertyComponentId]" (click)="setBackTo()">{{propertyComponent.name}}</a></td>
                            <td class="text-end">{{propertyComponent.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0' }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colspan="2"><a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/anticipated-expenditures']">View Anticipated Expenditures Report</a></td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <span class="section-title margin-top-20">Where your money is going</span>
    <div class="row section-container padding-bottom-0">
        <div class="col-md-12 categories">
            <div class="row text">
                <div class="col-md-12">
                    This chart identifies where you will spend money by category based on all your common area elements. Your current estimated common area replacement cost is {{reportData.componentInventoryReport.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}.
                    Typically, 80-90% of these costs come from two to three categories.
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 replacement-cost">
                    Current Replacement Cost: {{reportData.componentInventoryReport.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}
                </div>
            </div>
            <div class="row">
                <div #chartContainer class="col-md-12 categories-pie-chart">
                    <dx-pie-chart [dataSource]="chartData" [palette]="dxPieChartPalette" paletteExtensionMode="alternate"
                        resolveLabelOverlapping="hide" (onPointClick)="selectCategory($event)"
                        (onPointHoverChanged)="hoveredOnPieSlice($event)">
            
                        <dxo-pie-chart-margin [top]="20" [bottom]="20" [left]="50" [right]="10"></dxo-pie-chart-margin>
            
                        <!-- Data Mapping Setup-->
                        <dxi-pie-chart-series argumentField="name" valueField="value">
                            <dxo-pie-chart-label [visible]="true" position="columns" backgroundColor="none"
                                [customizeText]="customizeDxPieChartLabel">
                                <dxo-pie-chart-connector [visible]="true" [width]="1"></dxo-pie-chart-connector>
                                <dxo-pie-chart-font color="#000000" weight="300" family="MuseoSans-500, sans-serif"></dxo-pie-chart-font>
                            </dxo-pie-chart-label>
                        </dxi-pie-chart-series>
            
                        <!-- Hover Tooltip -->
                        <dxo-pie-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            paddingLeftRight="25" location="edge">
                        </dxo-pie-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="dx-tooltip-container">
                                {{info.argument}}
                                <br />
                                <strong><sp-fr [data]="info.value"></sp-fr></strong>
                            </div>
                        </div>
            
                        <!-- Legend -->
                        <dxo-pie-chart-legend [visible]="true">
                            <dxo-pie-chart-margin [left]="30"></dxo-pie-chart-margin>
                            <dxo-pie-chart-font color="#000000" weight="300" family="MuseoSans-500, sans-serif"></dxo-pie-chart-font>
                        </dxo-pie-chart-legend>
                    </dx-pie-chart>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-end margin-bottom-20">
                    <a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/component-inventory']">View {{ 'Component' | terminology | async }} Inventory Report</a>
                </div>
            </div>

            <div id="category-components">
                <ng-container *ngIf="selectedCategory">
                    <div class="row report-grid-header multiline">
                        <div class="col-md-4 text-start"><span>Name</span></div>
                        <div class="col-md-1 text-end"><span>UL</span></div>
                        <div class="col-md-1 text-end"><span>RUL</span></div>
                        <div class="col-md-3 text-end"><span>Current Replacement Cost</span></div>
                        <div class="col-md-3 text-end"><span>Anticipated Expenditures</span></div>
                    </div>

                    <div class="row report-section-header">
                        <div class="col-md-12">
                            {{ selectedCategory }}
                            <button class="btn btn-icon" (click)="selectedCategory = null" popover="Clear selected category" triggers="mouseenter:mouseleave" placement="right"><i class="fa fa-times fa-2x" aria-hidden="true"></i></button>
                        </div>
                    </div>

                    <div class="row report-grid-row" *ngFor="let item of selectedCategoryComponents">
                        <div class="col-md-4 text-start" [title]="item.name">
                            <a routerLink="/useraccount/components/{{item.propertyComponentId}}" (click)="setBackTo()" [innerHTML]="item.name | truncate : 50"></a>
                        </div>
                        <div class="col-md-1 text-end"><span>{{ item.usefulLife}}</span></div>
                        <div class="col-md-1 text-end"><span>{{ item.remainingUsefulLife}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.anticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                    </div>

                    <div class="row report-grid-row-total">
                        <div class="col-md-6 text-end"><span><strong>Total:</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalCurrentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalAnticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <span class="section-title margin-top-20">What does the future look like?</span>
    <div class="row section-container padding-bottom-0">
        <div class="col-md-12 future">
            <div class="row text">
                <div class="col-md-12">
                    {{reportData?.fundingReport.header.reportSummary}}
                </div>
            </div>

            <div class="row margin-top-20">
                <div class="col-md-3">
                    <select class="sp-select form-control" #years (change)="displayYearsDropdownChanged()">
                        <option value="5">Display 5 years</option>
                        <option value="10">Display 10 years</option>
                        <option value="15">Display 15 years</option>
                        <option value="20">Display 20 years</option>
                        <option value="25">Display 25 years</option>
                        <option value="30" selected>Display 30 years</option>
                    </select>
                </div>
                <div class="col-md-9 text-end">
                    <i class="fa fa-info-circle"></i>
                    <i>View individual expenditures per year by clicking on the blue vertical bars</i>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 report-chart">                    
                    <sp-devex-funding-report-chart 
                        [fundingReport]="reportData?.fundingReport"
                        [numberOfYears]="years.value"
                        (yearSelected)="selectYear($event)">
                    </sp-devex-funding-report-chart>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end margin-bottom-20">
                    <a class="btn btn-link padding-right-0" [routerLink]="['/useraccount/reports/plan', reportData?.fundingReport.planId]">View Your Funding Plan</a>
                </div>
            </div>

            <div id="anticipated-expenditures">
                <ng-container *ngIf="selectedYear">
                    <div class="row report-grid-header multiline">
                        <div class="col-md-3 text-start"><span>Name</span></div>
                        <div class="col-md-3 text-start"><span>Category</span></div>
                        <div class="col-md-3 text-end"><span>Current Replacement Cost</span></div>
                        <div class="col-md-3 text-end"><span>Anticipated Expenditures</span></div>
                    </div>

                    <div class="row report-section-header">
                        <div class="col-md-12">
                            {{ selectedYear }}
                            <button class="btn btn-icon" (click)="selectedYear = null" popover="Clear selected year" triggers="mouseenter:mouseleave" placement="right"><i class="fa fa-times fa-2x" aria-hidden="true"></i></button>
                        </div>
                    </div>

                    <div class="row report-grid-row" *ngFor="let item of selectedAnticipatedExpenditures">
                        <div class="col-md-3 text-start" [title]="item.name">
                            <a routerLink="/useraccount/components/{{item.propertyComponentId}}" (click)="setBackTo()" [innerHTML]="item.name | truncate : 50"></a>
                        </div>
                        <div class="col-md-3 text-start"><span>{{ item.propertyComponentCategoryName}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.currentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                        <div class="col-md-3 text-end"><span>{{ item.anticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</span></div>
                    </div>

                    <div class="row report-grid-row-total">
                        <div class="col-md-6 text-end"><span><strong>Total:</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalCurrentReplacementCost | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                        <div class="col-md-3 text-end"><span><strong>{{ totalAnticipatedExpenditures | currency:'USD':'symbol-narrow':'1.0-0'}}</strong></span></div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
